import "./gallery-carousel.scss";
import PropTypes from "prop-types";
import {
  CarouselArrow,
  CarouselDefault,
  CarouselDots,
  CarouselMarket,
} from "components/GecoComponentRouter/GalleryCarousel";
import { CarouselType } from "./constants";

/**
 * GalleryCarousel component
 * @param component
 * @param lang
 * @returns {JSX.Element}
 * @constructor
 */
export const GalleryCarousel = ({ component, lang }) => {
  const { id, fields } = component;
  const { marginBottom } = fields;

  const renderGalleryCarousel = () => {
    switch (fields.carouselType.staticValue[0] || CarouselType.CAROUSEL) {
      case CarouselType.CAROUSEL:
        return <CarouselDefault fields={fields} lang={lang} />;
      case CarouselType.DOTS:
        return <CarouselDots fields={fields} lang={lang} />;
      case CarouselType.ARROWS:
        return <CarouselArrow fields={fields} lang={lang} />;
      case CarouselType.MARKET:
        return <CarouselMarket fields={fields} lang={lang} />;
      default:
        return null;
    }
  };

  return (
    <div className={`galleryCarousel ${marginBottom.staticValue[0]}`} id={id}>
      {fields.carouselType?.staticValue[0] ? renderGalleryCarousel() : null}
    </div>
  );
};

GalleryCarousel.propTypes = {
  component: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    controlId: PropTypes.arrayOf(PropTypes.string),
    fields: PropTypes.shape({
      gallery: PropTypes.arrayOf(
        PropTypes.shape({
          media: PropTypes.shape({
            staticValue: PropTypes.shape({
              id: PropTypes.string,
              url: PropTypes.string,
              name: PropTypes.string,
              width: PropTypes.number,
              height: PropTypes.number,
              isDark: PropTypes.bool,
              type: PropTypes.oneOf(["Image", "Video", "Document"]),
              fileExtension: PropTypes.string,
            }),
          }),
          caption: PropTypes.shape({
            staticValue: PropTypes.string.isRequired,
          }),
          file: PropTypes.shape({
            staticValue: PropTypes.shape({
              id: PropTypes.string,
              url: PropTypes.string,
              name: PropTypes.string,
              width: PropTypes.number,
              height: PropTypes.number,
              isDark: PropTypes.bool,
              type: PropTypes.oneOf(["Image", "Video", "Document"]),
              fileExtension: PropTypes.string,
            }),
          }),
        }).isRequired
      ),
      carouselType: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf([
            CarouselType.CAROUSEL,
            CarouselType.DOTS,
            CarouselType.ARROWS,
            CarouselType.MARKET,
          ])
        ),
      }),
      marginBottom: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf([
            "margin__bottom__0",
            "margin__bottom__80",
            "margin__bottom__160",
            "margin__bottom__240",
          ])
        ).isRequired,
      }),
    }),
  }).isRequired,
  lang: PropTypes.string,
};
